// extracted by mini-css-extract-plugin
module.exports = {"base":"useModalExperimentStop_base__3U1Mi"};